// Generated by CoffeeScript 1.10.0
var React, objectAssign;

React = require('react');

objectAssign = require('object-assign');

module.exports = React.createClass({
  displayName: "Container",
  render: function() {
    var defaultStyles, styles;
    defaultStyles = {
      maxWidth: '960px',
      marginLeft: 'auto',
      marginRight: 'auto'
    };
    styles = objectAssign(defaultStyles, this.props.style);
    return React.createElement("div", Object.assign({}, this.props, {
      "style": styles
    }), this.props.children, React.createElement("span", {
      "style": {
        display: 'block',
        clear: 'both'
      }
    }, ' '));
  }
});



/*****************
 ** WEBPACK FOOTER
 ** ../~/react-responsive-grid/dist/components/Container.js
 ** module id = 372
 ** module chunks = 0
 **/